import React, { useEffect, useState } from 'react'
import { withRouter, useHistory, useParams } from 'react-router-dom'
import { onSubmitText } from '../../constantes/onSubmitText'
import { routes } from '../../constantes/routes'
import CloseBtn from '../buttons/CloseBtn'
import {
  swalAlertIsConfirm,
  swalAlertError,
  swalSuccessGeneral,
} from '../../utils/swalAlert'
import { swalTitle } from '../../constantes/swalTitle'
import ProfileForm from './ProfileForm'
import { usersApi } from '../../api/usersApi'
import validators from '../../utils/validationsRegEx'

const ProfileContainer = () => {
  let { id } = useParams()
  const history = useHistory()

  const [inputs, setinputs] = useState({
    nombre: '',
    email: '',
    telefono: '',
    roles: {
      nombre: '',
    },
    tipoZonas: {
      nombre: '',
    },
    id_TipoColor: '',
  })

  const [isDisable, setIsDisable] = useState(false)

  const toMain = () => {
    history.push(routes.MAIN)
  }

  useEffect(() => {
    getInfoUser(id)
  }, [id])

  const getInfoUser = async (idUser) => {
    try {
      const response = await usersApi.getUserById(idUser)
      console.log(response)
      Object.keys(inputs).map((input) =>
        setinputs((inputs) => ({ ...inputs, [input]: response.data[input] })),
      )
    } catch (error) {
      // toMain()
    }
  }

  const handleChange = (event) => {
    const value = event.target.value
    const name = event.target.name
    setinputs((inputs) => ({ ...inputs, [name]: value }))
  }

  const toChangePassword = () => {
    history.push(routes.CHANGE_PASSWORD_PROFILE + id)
  }

  const validateForm = () => {
    return (
      inputs.email.length > 0 &&
      validators.emailFormat(inputs.email) &&
      (inputs.telefono.length <= 0 ||
        (inputs.telefono.length > 0 &&
          validators.phoneNumberFormat(inputs.telefono))) &&
      inputs.nombre.length > 0
    )
  }

  const handleSubmit = async (event) => {
    event.preventDefault()
    try {
      setIsDisable(true)
      const response = await usersApi.updateUserProfile(inputs)
      swalSuccessGeneral(swalTitle.Actualizado, response)
      toMain()
    } catch (error) {
      swalAlertError(error.response.data || error.response.statusText)
      setIsDisable(false)
      toMain()
    }
  }

  return (
    <div className='products'>
      <div className='header mb-30'>
        <h3 className='header__title'>Editar perfil</h3>
        <div
          style={{
            display: 'inline-flex',
            alignItems: 'center',
            justifyContent: 'space-between',
          }}
        >
          <button
            className='btn-filter button-bg btn-shape'
            onClick={toChangePassword}
          >
            Cambiar contraseña
          </button>
          <button className='header__close' onClick={toMain}>
            <CloseBtn />
          </button>
        </div>
      </div>
      <ProfileForm
        inputs={inputs}
        handleChange={handleChange}
        isDisable={isDisable || !validateForm()}
        textBtn={onSubmitText.Guardar}
        handleSubmit={handleSubmit}
      />
    </div>
  )
}
export default withRouter(ProfileContainer)
